/**
 * Transform text into lowerSnakeCase
 * @param  {string} text text to transform
 * @param  {string} text separator character (default ' ')
 * @return {string}      transformed text
 */
export default function lowerSnakeTransform(text = '', sep = ' ') {
  return text.indexOf(sep) ?
    text.split(sep)
      .map((item, idx) => (
        0 === idx ?
          item.toLowerCase() :
          `${item.toLowerCase().charAt(0).toUpperCase()}${item.slice(1).toLowerCase()}`
      ))
      .join('') :
    text.toLowerCase();
}



// WEBPACK FOOTER //
// ./app/utils/string/lowerSnakeTransform.js